import React from "react";
import "./Styles/CategoryCard.css"

export default function CategoryCard(props) {
  const categoriesURL = process.env.REACT_APP_API_BASE_URL+'/images/categories/thumbs/';

  const goToCategory = (slug) => {
    window.location.href = '/boutique?category='+slug
  }

  return (
    <div onClick={()=>{goToCategory(props.slug)}} className="card-wrapper">
      
      <div className="card">
        
        <div className="card-image">
          <img src={categoriesURL+props.thumb} alt={props.slug}/>
        </div>

      <div className="details">
        <h2>{props.name}</h2>
      </div>
    </div>
  </div>
  );
}